module.exports = __webpack_public_path__ + "media/images/temp/slide-image-77bb90a21012a1e1775415250e774519.png";